// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { MPBetslipBandStyle } from '../../../../styled-components/dark/monopoly';
import { MPLogo } from '../../assets/svg';

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  border-radius: 8px;
  padding: 0.3em 1em;
  background-color: ${({ $isDark }) =>
    $isDark ? MPBetslipBandStyle.backgroundColorDark : MPBetslipBandStyle.backgroundColor};
  color: ${MPBetslipBandStyle.color};
  font-size: 1em;

  ${({ $isCompact }) =>
    $isCompact
      ? css`
          padding: 0.2em 0.3em;
          font-size: 0.8em;
          gap: 0.2em;
        `
      : null}

  ${({ $isFullWidth }) =>
    $isFullWidth
      ? css`
          display: flex;
          justify-content: center;
        `
      : null}
`;

const StyledMonopolyLogo = styled(MPLogo)`
  height: 1.5em;
  width: 1.5em;
  margin-right: 0.3em;

  ${({ $isCompact }) =>
    $isCompact
      ? css`
          height: 1.2em;
          width: 1.2em;
          margin-right: 0.2em;
        `
      : null}
`;

const Label = styled.div`
  font-weight: bold;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const CardImg = styled.img`
  height: 1.125em;
  width: 0.75em;
  margin-right: 0.3em;

  ${({ $isCompact }) =>
    $isCompact
      ? css`
          height: 1em;
          width: 0.6em;
          margin-right: 0.2em;
        `
      : null}
`;

type MPBetslipBandProps = {
  className?: string;
  cardIconImgPath: string;
  cardName: string;
  isDark: boolean;
  isCompact?: boolean;
  isFullWidth?: boolean;
};

const MPBetslipBand = ({
  className = '',
  cardIconImgPath,
  cardName,
  isCompact = false,
  isDark = false,
  isFullWidth = false,
}: MPBetslipBandProps) => {
  return (
    <Wrapper className={className} $isCompact={isCompact} $isFullWidth={isFullWidth} $isDark={isDark}>
      <StyledMonopolyLogo $isCompact={isCompact} />
      <CardImg src={cardIconImgPath} $isCompact={isCompact} />
      <Label>{cardName}</Label>
    </Wrapper>
  );
};

export default MPBetslipBand;
